import { So5LeaderboardSeasonality } from '__generated__/globalTypes';
import { unitMapping } from 'lib/style';

import allSeasons from './assets/all_seasons.svg';
import inSeason from './assets/in_season.svg';

const iconBySeasonality: Record<So5LeaderboardSeasonality, string> = {
  [So5LeaderboardSeasonality.ALL_SEASONS]: allSeasons,
  [So5LeaderboardSeasonality.IN_SEASON]: inSeason,
};

type Props = {
  seasonality: So5LeaderboardSeasonality;
  size?: keyof typeof unitMapping;
};

export const SeasonalityIcon = ({ seasonality, size = 2 }: Props) => {
  return (
    <img
      src={iconBySeasonality[seasonality]}
      alt={seasonality}
      style={{ width: unitMapping[size] }}
    />
  );
};
